const Configuration = {
  // apiServer: 'http://127.0.0.1:3001',
  // staticServer: 'http://127.0.0.1:5002',
  // wsServer: 'http://127.0.0.1:5004',
  apiServer: 'https://api-industrial.visitapp.io',
  staticServer: 'https://static-industrial.visitapp.io',
  wsServer: 'https://ws-industrial.visitapp.io',
  isInRol(rol, rols) {
    const list = rols.split(" or ");

    if(rol && list.indexOf(rol.toLowerCase()) > -1) {
      return true;
    } else {
      return false;
    }
  },
  redirectUrl(rol) {  
    const rols = {Root: '/admin/departments', Admin: '/admin/departments', Gerente: '/admin/cars', Empleado: '/admin/cars', Guardia: '/access'};
    return rols[rol];
  },
  getStatus(status) {
    if(status) {
      return {color: 'success', text: 'Activo'};
    } else {
      return {color: 'danger', text: 'Inactivo'};
    }
  },
  getBadgeStatus(status) {
    if(status) {
      return {color: 'green', text: 'Resuelto'};
    } else {
      return {color: 'gold', text: 'Pendiente'};
    }
  },
  getVisitStatus(status) {
    switch(status) {
      case 'pending':
        return {color: 'gold', hex: '#FEBF07', text: 'Pendiente'};
      case 'authorized':
        return {color: 'green', hex: '#00D755', text: 'Autorizada'};
      case 'denied':
        return {color: 'red', hex: '#FF0007', text: 'Denegada'};
      case 'start_weight_machine':
        return {color: 'volcano', hex: '#FF3B4F', text: 'Entrada a báscula'};
      case 'leave_weight_machine':
        return {color: 'volcano', hex: '#FF3B4F', text: 'Salida de báscula'};
      case 'weight_authorized':
        return {color: 'green', hex: '#00D755', text: 'Salida autorizada'};
      case 'weight_pending':
        return {color: 'red', hex: '#FF0007', text: 'Salida por autorizar'};
      case 'weight_denied':
        return {color: 'red', hex: '#FF0007', text: 'Salida negada'};
      case 'access':
        return {color: 'lime', hex: '#9DEC0E', text: 'En planta'};
      case 'reception':
        return {color: 'volcano', hex: '#FF3B4F', text: 'En recepción'};
      case 'personal':
        return {color: 'blue', hex: '#2A78FF', text: 'Recibida'};
      case 'leave':
        return {color: 'magenta', hex: '#FE5193', text: 'Ha salido'};
      default: 
        return {color: 'gold', hex: '#FEBF07', text: 'Pendiente'};
    }
  },
  displayElement(status) {
    if(status) {
      return 'block';
    } else {
      return 'none';
    }
  },
  formatDatetime(date) {
    if(date) {
      const newDate = new Date(date);
      return `${newDate.getDate()} / ${newDate.getMonth() + 1} / ${newDate.getFullYear()} ${newDate.getHours()}:${newDate.getMinutes()}`;
    } else {
      return 'Sin fecha';
    }
  },
  formatDate(date) {
    if(date) {
      const newDate = new Date(date);
      return `${newDate.getDate()} / ${newDate.getMonth() + 1} / ${newDate.getFullYear()}`;
    } else {
      return 'Sin fecha';
    }
  },
  formatTime(date) {
    if(date) {
      const newDate = new Date(date);
      return `${newDate.getHours()}:${newDate.getMinutes()}`;
    } else {
      return 'Sin fecha';
    }
  },
  stayTime(start, end) {
    if(start && end) {
      const startDate = new Date(start).getTime();
      const endDate = new Date(end).getTime()
      const stay = endDate - startDate;
      
      return Math.ceil((stay / 1000) / 60);
    } else {
      return 'Pendiente';
    }
  }
};

export default Configuration;



// WEBPACK FOOTER //
// ./src/Configuration.js